import { Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
// import { EditorService } from '../editors/services/editor.service';
import { EditorInputDirective } from '../editors/directives/editor-input.directive';
import { DynamicInputComponent, MenuGroup } from '../editors/dynamic-input-model';
import { InputDataInterFace } from './input-data-interface';

@Component({
  selector: 'kv-editor-input-container',
  templateUrl: './editor-input-container.component.html',
  styleUrls: ['./editor-input-container.component.scss']
})
export class EditorInputContainerComponent implements OnInit, OnChanges {
  @Input() inputComponent: DynamicInputComponent;
  @Input() menuGroups: MenuGroup[];
  currentComponent: any;

  @ViewChild(EditorInputDirective, { static: false }) editorInputTemplate!: EditorInputDirective;

  constructor() { }

  ngOnInit(): void {

  }

  ngOnChanges(changes: SimpleChanges): void {
    // Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    // Add '${implements OnChanges}' to the class.
    if (changes["inputComponent"]) {
      this.currentComponent = this.inputComponent.component;
    }
  }

  ngAfterViewInit(): void {
    // Called after ngAfterContentInit when the component's view has been initialized. Applies to components only.
    // Add 'implements AfterViewInit' to the class.
    this.loadComponent(this.currentComponent)
  }
  loadComponent(currentComponent) {
    // const workBenchItem = currentComponent;
    // const componentFactory = this.componentFactoryResolver.resolveComponentFactory(currentComponent);
    // console.log(componentFactory.componentType);

    const viewContainerRef = this.editorInputTemplate.viewContainerRef; // this.ngxWorkbench.viewContainerRef;
    // const componentRef = viewContainerRef.createComponent(componentFactory);
    const componentRef = viewContainerRef.createComponent(currentComponent);
    // (componentRef.instance)["menuGroups"] = this.menuGroups;
    (<InputDataInterFace>componentRef.instance).data = this.inputComponent.data;
    componentRef.changeDetectorRef.detectChanges();
  }
}
